import { Button, Divider, Group, Stack } from '@common/ui'
import { com } from '@eidu/web'
import AndOrSelector from './AndOrSelector'
import NotSelector from './NotSelector'
import EntitySelector = com.eidu.entity.selector.EntitySelector
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import NonEmptyList = com.quickbirdstudios.nonEmptyCollection.list.NonEmptyList
import TargetSelectorInput from './TargetSelectorInput'
import EntitySelectorInput from './EntitySelectorInput'
import { SelectorType } from './SelectorType'

type SelectorEditorProps = {
  selector: EntitySelector
  onChange: (newSelector: EntitySelector) => void
  entityTypes: readonly EntityType[]
  selectorType: SelectorType
  enableNot?: boolean
  enableAnd?: boolean
  lockedEntityTypeId?: EntityTypeId
}

const SelectorEditor = ({
  selector,
  onChange,
  entityTypes,
  selectorType,
  enableNot,
  enableAnd,
  lockedEntityTypeId,
}: SelectorEditorProps) => {
  if (selector instanceof EntitySelector.Not) {
    return (
      <NotSelector
        selector={selector}
        entityTypes={entityTypes}
        onChange={onChange}
        selectorType={selectorType}
        lockedEntityTypeId={lockedEntityTypeId}
      />
    )
  } else if (selector instanceof EntitySelector.And || selector instanceof EntitySelector.Or) {
    return (
      <AndOrSelector
        selector={selector}
        entityTypes={entityTypes}
        onChange={onChange}
        selectorType={selectorType}
        lockedEntityTypeId={lockedEntityTypeId}
      />
    )
  } else {
    return (
      <div style={{ width: '100%' }}>
        <Group gap="xs" align="center" wrap="nowrap" style={{ width: '100%' }}>
          {selectorType === 'target' ? (
            <TargetSelectorInput entityTypes={entityTypes} entitySelector={selector} setEntitySelector={onChange} />
          ) : (
            <EntitySelectorInput
              entityTypes={entityTypes}
              entitySelector={selector}
              setEntitySelector={onChange}
              lockedEntityTypeId={lockedEntityTypeId}
            />
          )}
          <Divider />
          <Stack gap="xs" align="center" justify="center">
            {enableAnd && (
              <Button
                variant="subtle"
                size="xs"
                onClick={() => onChange(new EntitySelector.And(NonEmptyList.fromArray([selector])))}
              >
                Group AND
              </Button>
            )}
            {enableNot && (
              <Button variant="subtle" size="xs" onClick={() => onChange(new EntitySelector.Not(selector))}>
                NOT
              </Button>
            )}
          </Stack>
        </Group>
      </div>
    )
  }
}

export default SelectorEditor
